<div class="row">
  <div class="custom-card extend-card">
    <div class="col-12">
      <table mat-table class="tabletop" [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="packageNo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>No.of Package</th>
          <td mat-cell *matCellDef="let element">
            <input
              type="number"
              class="input-value form-control"
              [(ngModel)]="element.packageNo"
              [value]="element?.packageNo"
              (keyup)="onKeyRelease($event)"
              (mouseleave)="onKeyRelease($event)" />
          </td>
        </ng-container>
        <ng-container matColumnDef="packageWeight">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Weight</th>
          <td mat-cell *matCellDef="let element">
            <input
              type="number"
              class="input-value form-control"
              [(ngModel)]="element.packageWeight"
              [value]="element?.packageWeight"
              (keyup)="onKeyRelease($event)"
              (mouseleave)="onKeyRelease($event)" />
          </td>
        </ng-container>
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef>Action</th>
          <td mat-cell *matCellDef="let row; let i = index">
            <i
              class="m-1 icon-mat"
              [matTooltip]="'Add'"
              *ngIf="dataSource.data.length - 1 == row.index"
              mat-raised-button
              (click)="Add()">
              <em class="bi bi-plus"></em>
            </i>
            <i [matTooltip]="'Delete'" (click)="remove(row)" class="m-1 icon-mat bi bi-trash"></i>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
</div>
